import type { AreaDict } from '../messages'

// Gerenciamento: Categorias, Tags e Usuários. pt-BR = textos atuais do app.
const manage: AreaDict = {
  'pt-BR': {
    // Compartilhados
    'mng.enable': 'Habilitar',
    'mng.disable': 'Desabilitar',
    'mng.disabledBadge': 'desabilitada',
    'mng.errChange': 'Erro ao alterar',
    'mng.errSave': 'Erro ao salvar',
    'mng.errDelete': 'Erro ao excluir',
    'mng.deleteTitle': 'Excluir "{name}"?',

    // Categorias
    'mng.cat.subtitle': 'Categorias e subcategorias. Desabilitar mantém o histórico e some dos seletores.',
    'mng.cat.showArchived': 'Mostrar desabilitadas',
    'mng.cat.hideArchived': 'Ocultar desabilitadas',
    'mng.cat.new': 'Nova categoria',
    'mng.cat.emptyTitle': 'Nenhuma categoria ainda',
    'mng.cat.emptyDesc': 'Crie categorias e subcategorias para organizar suas receitas e despesas.',
    'mng.cat.expenses': 'Despesas',
    'mng.cat.incomes': 'Receitas',
    'mng.cat.investments': 'Investimentos',
    'mng.cat.emptyExpenses': 'Nenhuma categoria de despesas.',
    'mng.cat.emptyIncomes': 'Nenhuma categoria de receitas.',
    'mng.cat.emptyInvestments': 'Nenhuma categoria de investimentos.',
    'mng.cat.level': 'Nível',
    'mng.cat.main': 'Principal',
    'mng.cat.sub': 'Subcategoria',
    'mng.cat.enabledToast': 'Categoria habilitada',
    'mng.cat.disabledToast': 'Categoria desabilitada',
    'mng.cat.errCheck': 'Erro ao verificar a categoria',
    'mng.cat.delTxWarn': '{count} transação(ões) ficarão SEM categoria',
    'mng.cat.delChildWarn': '{count} subcategoria(s) serão excluídas junto',
    'mng.cat.delBudgetWarn': 'os orçamentos desta categoria serão apagados',
    'mng.cat.deleteTail': 'Esta ação não pode ser desfeita — se quiser apenas parar de usá-la, prefira desabilitar.',
    'mng.cat.deleted': 'Categoria excluída',
    // CategoryFormDialog
    'mng.cat.nameRequired': 'Informe um nome',
    'mng.cat.updated': 'Categoria atualizada',
    'mng.cat.created': 'Categoria criada',
    'mng.cat.editTitle': 'Editar categoria',
    'mng.cat.dialogDesc': 'Subcategorias herdam o tipo (receita / despesa / investimento) da principal.',
    'mng.cat.type': 'Tipo',
    'mng.cat.expense': 'Despesa',
    'mng.cat.income': 'Receita',
    'mng.cat.investment': 'Investimento',
    'mng.cat.investNote1': 'No Orçamento, o ',
    'mng.cat.investNoteBold1': 'investimento',
    'mng.cat.investNote2': ' entra como ',
    'mng.cat.investNoteBold2': 'resultado líquido',
    'mng.cat.investNote3':
      ' (ganhos − perdas), positivo ou negativo — nem receita nem despesa. Os lançamentos podem ser ganho (receita) ou perda (despesa).',
    'mng.cat.icon': 'Ícone',
    'mng.cat.name': 'Nome',
    'mng.cat.namePlaceholder': 'Ex.: Mercado',
    'mng.cat.parent': 'Categoria principal',
    'mng.cat.noneParent': 'Nenhuma (categoria principal)',
    'mng.cat.searchParent': 'Buscar categoria…',
    'mng.cat.hasChildrenNote': 'Esta categoria tem subcategorias, por isso não pode virar subcategoria.',

    // Tags
    'mng.tag.subtitle': 'Tags marcam transações (ex.: DOCAVISA). Desabilitar mantém o histórico e some dos seletores.',
    'mng.tag.new': 'Nova tag',
    'mng.tag.emptyTitle': 'Nenhuma tag ainda',
    'mng.tag.emptyDesc': 'Crie a primeira tag para marcar e agrupar suas transações.',
    'mng.tag.colTag': 'Tag',
    'mng.tag.colDesc': 'Descrição',
    'mng.tag.colTx': 'Transações',
    'mng.tag.enabledToast': 'Tag habilitada',
    'mng.tag.disabledToast': 'Tag desabilitada',
    'mng.tag.delWarn':
      'A tag será removida de {count} transação(ões). O histórico é preservado — só a marcação some. Se quiser apenas parar de usá-la, prefira desabilitar.',
    'mng.tag.delNoTx': 'Esta ação não pode ser desfeita.',
    'mng.tag.deleted': 'Tag excluída',

    // Usuários
    'mng.user.subtitle1': 'Quem pode entrar no app. Todo usuário aqui tem acesso ',
    'mng.user.subtitleBold': 'completo',
    'mng.user.subtitle2': ' às finanças — não há níveis de permissão.',
    'mng.user.new': 'Novo usuário',
    'mng.user.emptyTitle': 'Nenhum usuário ainda',
    'mng.user.emptyDesc': 'Adicione o primeiro usuário para dar acesso ao app.',
    'mng.user.colEmail': 'E-mail',
    'mng.user.colCreated': 'Criado em',
    'mng.user.colLastAccess': 'Último acesso',
    'mng.user.you': 'você',
    'mng.user.createdToast': 'Usuário {email} criado',
    'mng.user.errCreate': 'Não foi possível criar',
    'mng.user.removeTitle': 'Remover {email}?',
    'mng.user.removeDesc': 'O acesso é revogado imediatamente. Os dados financeiros não são afetados.',
    'mng.user.removed': 'Usuário removido',
    'mng.user.errRemove': 'Não foi possível remover',
    'mng.user.dialogDesc': 'O usuário já nasce confirmado e pode entrar na hora — nenhum e-mail de verificação é enviado.',
    'mng.user.password': 'Senha',
    'mng.user.passwordPlaceholder': 'mínimo 8 caracteres',
    'mng.user.passwordHint': 'Anote e passe para a pessoa — a senha não é exibida de novo depois.',
    'mng.user.creating': 'Criando…',
    'mng.user.create': 'Criar',
    'mng.user.cantRemoveSelf': 'Você não pode remover o próprio usuário',
    'mng.user.colTenant': 'Tenant',
    'mng.user.colRole': 'Papel',
    'mng.role.owner': 'ADM',
    'mng.role.member': 'Adicional',
    'mng.user.noTenant': 'sem tenant',
    'mng.user.tenantLabel': 'Tenant',
    'mng.user.roleLabel': 'Papel',
    'mng.user.superBadge': 'super-admin',
    'mng.user.newTenant': 'Novo tenant',
    'mng.user.newTenantOwnerHint': 'Este usuário será o dono (owner) do novo tenant.',
    'mng.user.platformNewDesc': 'O usuário será dono (owner) de um tenant novo, isolado dos demais.',
    'mng.user.tenantNameOptional': '(opcional — padrão: e-mail)',
    'mng.user.move': 'Mover de tenant',
    'mng.user.moveTitle': 'Mover {email}',
    'mng.user.moved': 'Usuário movido',
    'mng.user.errMove': 'Não foi possível mover',
    'mng.tenant.name': 'Nome do tenant',
    'mng.tenant.create': 'Criar tenant',
    'mng.tenant.creating': 'Criando…',
    'mng.tenant.created': 'Tenant criado',
    'mng.tenant.errCreate': 'Não foi possível criar o tenant',
  },
  en: {
    // Shared
    'mng.enable': 'Enable',
    'mng.disable': 'Disable',
    'mng.disabledBadge': 'disabled',
    'mng.errChange': 'Error while updating',
    'mng.errSave': 'Error while saving',
    'mng.errDelete': 'Error while deleting',
    'mng.deleteTitle': 'Delete "{name}"?',

    // Categories
    'mng.cat.subtitle': 'Categories and subcategories. Disabling keeps the history and hides them from selectors.',
    'mng.cat.showArchived': 'Show disabled',
    'mng.cat.hideArchived': 'Hide disabled',
    'mng.cat.new': 'New category',
    'mng.cat.emptyTitle': 'No categories yet',
    'mng.cat.emptyDesc': 'Create categories and subcategories to organize your income and expenses.',
    'mng.cat.expenses': 'Expenses',
    'mng.cat.incomes': 'Income',
    'mng.cat.investments': 'Investments',
    'mng.cat.emptyExpenses': 'No expense categories.',
    'mng.cat.emptyIncomes': 'No income categories.',
    'mng.cat.emptyInvestments': 'No investment categories.',
    'mng.cat.level': 'Level',
    'mng.cat.main': 'Main',
    'mng.cat.sub': 'Subcategory',
    'mng.cat.enabledToast': 'Category enabled',
    'mng.cat.disabledToast': 'Category disabled',
    'mng.cat.errCheck': 'Error while checking the category',
    'mng.cat.delTxWarn': '{count} transaction(s) will be left WITHOUT a category',
    'mng.cat.delChildWarn': '{count} subcategory(ies) will be deleted along with it',
    'mng.cat.delBudgetWarn': 'the budgets of this category will be deleted',
    'mng.cat.deleteTail': 'This action cannot be undone — if you just want to stop using it, prefer disabling.',
    'mng.cat.deleted': 'Category deleted',
    // CategoryFormDialog
    'mng.cat.nameRequired': 'Enter a name',
    'mng.cat.updated': 'Category updated',
    'mng.cat.created': 'Category created',
    'mng.cat.editTitle': 'Edit category',
    'mng.cat.dialogDesc': 'Subcategories inherit the type (income / expense / investment) from the main one.',
    'mng.cat.type': 'Type',
    'mng.cat.expense': 'Expense',
    'mng.cat.income': 'Income',
    'mng.cat.investment': 'Investment',
    'mng.cat.investNote1': 'In the Budget, the ',
    'mng.cat.investNoteBold1': 'investment',
    'mng.cat.investNote2': ' enters as a ',
    'mng.cat.investNoteBold2': 'net result',
    'mng.cat.investNote3':
      ' (gains − losses), positive or negative — neither income nor expense. Entries can be a gain (income) or a loss (expense).',
    'mng.cat.icon': 'Icon',
    'mng.cat.name': 'Name',
    'mng.cat.namePlaceholder': 'E.g.: Groceries',
    'mng.cat.parent': 'Main category',
    'mng.cat.noneParent': 'None (main category)',
    'mng.cat.searchParent': 'Search category…',
    'mng.cat.hasChildrenNote': 'This category has subcategories, so it cannot become a subcategory.',

    // Tags
    'mng.tag.subtitle': 'Tags mark transactions (e.g.: DOCAVISA). Disabling keeps the history and hides them from selectors.',
    'mng.tag.new': 'New tag',
    'mng.tag.emptyTitle': 'No tags yet',
    'mng.tag.emptyDesc': 'Create the first tag to mark and group your transactions.',
    'mng.tag.colTag': 'Tag',
    'mng.tag.colDesc': 'Description',
    'mng.tag.colTx': 'Transactions',
    'mng.tag.enabledToast': 'Tag enabled',
    'mng.tag.disabledToast': 'Tag disabled',
    'mng.tag.delWarn':
      'The tag will be removed from {count} transaction(s). The history is preserved — only the tagging disappears. If you just want to stop using it, prefer disabling.',
    'mng.tag.delNoTx': 'This action cannot be undone.',
    'mng.tag.deleted': 'Tag deleted',

    // Users
    'mng.user.subtitle1': 'Who can sign in to the app. Every user here has ',
    'mng.user.subtitleBold': 'full',
    'mng.user.subtitle2': ' access to the finances — there are no permission levels.',
    'mng.user.new': 'New user',
    'mng.user.emptyTitle': 'No users yet',
    'mng.user.emptyDesc': 'Add the first user to grant access to the app.',
    'mng.user.colEmail': 'Email',
    'mng.user.colCreated': 'Created on',
    'mng.user.colLastAccess': 'Last access',
    'mng.user.you': 'you',
    'mng.user.createdToast': 'User {email} created',
    'mng.user.errCreate': 'Could not create',
    'mng.user.removeTitle': 'Remove {email}?',
    'mng.user.removeDesc': 'Access is revoked immediately. Financial data is not affected.',
    'mng.user.removed': 'User removed',
    'mng.user.errRemove': 'Could not remove',
    'mng.user.dialogDesc': 'The user is created already confirmed and can sign in right away — no verification email is sent.',
    'mng.user.password': 'Password',
    'mng.user.passwordPlaceholder': 'minimum 8 characters',
    'mng.user.passwordHint': 'Write it down and share it with the person — the password is not shown again afterward.',
    'mng.user.creating': 'Creating…',
    'mng.user.create': 'Create',
    'mng.user.cantRemoveSelf': 'You cannot remove your own user',
    'mng.user.colTenant': 'Tenant',
    'mng.user.colRole': 'Role',
    'mng.role.owner': 'Admin',
    'mng.role.member': 'Additional',
    'mng.user.noTenant': 'no tenant',
    'mng.user.tenantLabel': 'Tenant',
    'mng.user.roleLabel': 'Role',
    'mng.user.superBadge': 'super-admin',
    'mng.user.newTenant': 'New tenant',
    'mng.user.newTenantOwnerHint': 'This user will be the owner of the new tenant.',
    'mng.user.platformNewDesc': 'The user will be the owner of a brand-new tenant, isolated from the others.',
    'mng.user.tenantNameOptional': '(optional — defaults to the email)',
    'mng.user.move': 'Move tenant',
    'mng.user.moveTitle': 'Move {email}',
    'mng.user.moved': 'User moved',
    'mng.user.errMove': 'Could not move',
    'mng.tenant.name': 'Tenant name',
    'mng.tenant.create': 'Create tenant',
    'mng.tenant.creating': 'Creating…',
    'mng.tenant.created': 'Tenant created',
    'mng.tenant.errCreate': 'Could not create tenant',
  },
  es: {
    // Compartidos
    'mng.enable': 'Habilitar',
    'mng.disable': 'Deshabilitar',
    'mng.disabledBadge': 'deshabilitada',
    'mng.errChange': 'Error al cambiar',
    'mng.errSave': 'Error al guardar',
    'mng.errDelete': 'Error al eliminar',
    'mng.deleteTitle': '¿Eliminar "{name}"?',

    // Categorías
    'mng.cat.subtitle': 'Categorías y subcategorías. Deshabilitar mantiene el historial y las oculta de los selectores.',
    'mng.cat.showArchived': 'Mostrar deshabilitadas',
    'mng.cat.hideArchived': 'Ocultar deshabilitadas',
    'mng.cat.new': 'Nueva categoría',
    'mng.cat.emptyTitle': 'Aún no hay categorías',
    'mng.cat.emptyDesc': 'Crea categorías y subcategorías para organizar tus ingresos y gastos.',
    'mng.cat.expenses': 'Gastos',
    'mng.cat.incomes': 'Ingresos',
    'mng.cat.investments': 'Inversiones',
    'mng.cat.emptyExpenses': 'Ninguna categoría de gastos.',
    'mng.cat.emptyIncomes': 'Ninguna categoría de ingresos.',
    'mng.cat.emptyInvestments': 'Ninguna categoría de inversiones.',
    'mng.cat.level': 'Nivel',
    'mng.cat.main': 'Principal',
    'mng.cat.sub': 'Subcategoría',
    'mng.cat.enabledToast': 'Categoría habilitada',
    'mng.cat.disabledToast': 'Categoría deshabilitada',
    'mng.cat.errCheck': 'Error al verificar la categoría',
    'mng.cat.delTxWarn': '{count} transacción(es) quedarán SIN categoría',
    'mng.cat.delChildWarn': '{count} subcategoría(s) se eliminarán junto con ella',
    'mng.cat.delBudgetWarn': 'los presupuestos de esta categoría se borrarán',
    'mng.cat.deleteTail': 'Esta acción no se puede deshacer — si solo quieres dejar de usarla, mejor deshabilítala.',
    'mng.cat.deleted': 'Categoría eliminada',
    // CategoryFormDialog
    'mng.cat.nameRequired': 'Indica un nombre',
    'mng.cat.updated': 'Categoría actualizada',
    'mng.cat.created': 'Categoría creada',
    'mng.cat.editTitle': 'Editar categoría',
    'mng.cat.dialogDesc': 'Las subcategorías heredan el tipo (ingreso / gasto / inversión) de la principal.',
    'mng.cat.type': 'Tipo',
    'mng.cat.expense': 'Gasto',
    'mng.cat.income': 'Ingreso',
    'mng.cat.investment': 'Inversión',
    'mng.cat.investNote1': 'En el Presupuesto, la ',
    'mng.cat.investNoteBold1': 'inversión',
    'mng.cat.investNote2': ' entra como ',
    'mng.cat.investNoteBold2': 'resultado neto',
    'mng.cat.investNote3':
      ' (ganancias − pérdidas), positivo o negativo — ni ingreso ni gasto. Los movimientos pueden ser ganancia (ingreso) o pérdida (gasto).',
    'mng.cat.icon': 'Icono',
    'mng.cat.name': 'Nombre',
    'mng.cat.namePlaceholder': 'Ej.: Supermercado',
    'mng.cat.parent': 'Categoría principal',
    'mng.cat.noneParent': 'Ninguna (categoría principal)',
    'mng.cat.searchParent': 'Buscar categoría…',
    'mng.cat.hasChildrenNote': 'Esta categoría tiene subcategorías, por eso no puede convertirse en subcategoría.',

    // Etiquetas
    'mng.tag.subtitle': 'Las etiquetas marcan transacciones (ej.: DOCAVISA). Deshabilitar mantiene el historial y las oculta de los selectores.',
    'mng.tag.new': 'Nueva etiqueta',
    'mng.tag.emptyTitle': 'Aún no hay etiquetas',
    'mng.tag.emptyDesc': 'Crea la primera etiqueta para marcar y agrupar tus transacciones.',
    'mng.tag.colTag': 'Etiqueta',
    'mng.tag.colDesc': 'Descripción',
    'mng.tag.colTx': 'Transacciones',
    'mng.tag.enabledToast': 'Etiqueta habilitada',
    'mng.tag.disabledToast': 'Etiqueta deshabilitada',
    'mng.tag.delWarn':
      'La etiqueta se quitará de {count} transacción(es). El historial se conserva — solo desaparece la marca. Si solo quieres dejar de usarla, mejor deshabilítala.',
    'mng.tag.delNoTx': 'Esta acción no se puede deshacer.',
    'mng.tag.deleted': 'Etiqueta eliminada',

    // Usuarios
    'mng.user.subtitle1': 'Quién puede entrar en la app. Todo usuario aquí tiene acceso ',
    'mng.user.subtitleBold': 'completo',
    'mng.user.subtitle2': ' a las finanzas — no hay niveles de permiso.',
    'mng.user.new': 'Nuevo usuario',
    'mng.user.emptyTitle': 'Aún no hay usuarios',
    'mng.user.emptyDesc': 'Agrega el primer usuario para dar acceso a la app.',
    'mng.user.colEmail': 'Correo electrónico',
    'mng.user.colCreated': 'Creado el',
    'mng.user.colLastAccess': 'Último acceso',
    'mng.user.you': 'tú',
    'mng.user.createdToast': 'Usuario {email} creado',
    'mng.user.errCreate': 'No se pudo crear',
    'mng.user.removeTitle': '¿Quitar {email}?',
    'mng.user.removeDesc': 'El acceso se revoca de inmediato. Los datos financieros no se ven afectados.',
    'mng.user.removed': 'Usuario quitado',
    'mng.user.errRemove': 'No se pudo quitar',
    'mng.user.dialogDesc': 'El usuario nace ya confirmado y puede entrar al instante — no se envía ningún correo de verificación.',
    'mng.user.password': 'Contraseña',
    'mng.user.passwordPlaceholder': 'mínimo 8 caracteres',
    'mng.user.passwordHint': 'Anótala y pásala a la persona — la contraseña no se muestra de nuevo después.',
    'mng.user.creating': 'Creando…',
    'mng.user.create': 'Crear',
    'mng.user.cantRemoveSelf': 'No puedes quitar tu propio usuario',
    'mng.user.colTenant': 'Tenant',
    'mng.user.colRole': 'Rol',
    'mng.role.owner': 'Admin',
    'mng.role.member': 'Adicional',
    'mng.user.noTenant': 'sin tenant',
    'mng.user.tenantLabel': 'Tenant',
    'mng.user.roleLabel': 'Rol',
    'mng.user.superBadge': 'super-admin',
    'mng.user.newTenant': 'Nuevo tenant',
    'mng.user.newTenantOwnerHint': 'Este usuario será el dueño (owner) del nuevo tenant.',
    'mng.user.platformNewDesc': 'El usuario será dueño (owner) de un tenant nuevo, aislado de los demás.',
    'mng.user.tenantNameOptional': '(opcional — por defecto: el correo)',
    'mng.user.move': 'Mover de tenant',
    'mng.user.moveTitle': 'Mover {email}',
    'mng.user.moved': 'Usuario movido',
    'mng.user.errMove': 'No se pudo mover',
    'mng.tenant.name': 'Nombre del tenant',
    'mng.tenant.create': 'Crear tenant',
    'mng.tenant.creating': 'Creando…',
    'mng.tenant.created': 'Tenant creado',
    'mng.tenant.errCreate': 'No se pudo crear el tenant',
  },
}

export default manage
